import HeroMonthlyHistogramContainer from '../../../../components/containers/HeroMonthlyHistogramContainer';
import preloadCustomProps from '../../../utils/preloads/preloadHistogramProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'hero-monthly-histogram',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: HeroMonthlyHistogramContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
